<template>
  <b-card
    no-body
    class="consignment-price-container"
    :class="[selected && 'selected-consignment-price']"
  >
    <b-card-body>
      <div class="consignment-price">
        <div class="consignment-price-details">
          <div class="consignment-price-left">
            <div class="consignment-price-logo">
              <div class="consignment-price-logo-container">
                <img :src="getProviderLogo(data)" />
              </div>

              <span>{{ data.name }}</span>
            </div>
            <div class="consignment-price-informations">
              <div>
                <span>{{ t('Region') }}:</span> {{ data.region }}
              </div>
              <div>
                <span>{{ t('Estimated Return Freight Charge') }}:</span> {{ data.price * 2 }}
                {{ data.currency }}
              </div>
              <div>
                <span>{{ t('Estimated Minimum Arrival Time') }}:</span> {{ data.etaMin || '-' }}
              </div>
              <div>
                <span>{{ t('Estimated Maximum Arrival Time') }}:</span> {{ data.etaMax || '-' }}
              </div>
            </div>
          </div>

          <div class="consignment-price-right">
            <div class="consignment-best-price">
              <b-badge v-if="data.cheapest" pill variant="success cursor-pointer">
                {{ t('Cheapest') }}
              </b-badge>
              <span>{{ data.price }} {{ data.currency }} </span>
            </div>
            <div class="consignment-select-offer">
              <template v-if="showDetail">
                <b-button
                  v-if="!selected"
                  variant="primary"
                  type="button"
                  size="sm"
                  @click="setConsignmentPrice(data.id)"
                >
                  {{ t('Select Offer') }}
                </b-button>
                <b-button v-else variant="secondary" type="button" size="sm" disabled>
                  {{ t('Offer Selected') }}
                </b-button>
              </template>
              <template v-else>
                <b-button
                  variant="primary"
                  type="button"
                  size="sm"
                  @click="createConsignment(data.id)"
                >
                  {{ t('Create Consignment') }}
                </b-button>
              </template>
            </div>
          </div>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import { BBadge, BButton, BCard, BCardBody } from 'bootstrap-vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { getProviderLogo } from '@/libs/providerHelper';

export default {
  components: {
    BButton,
    BBadge,
    BCardBody,
    BCard
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    selected: {
      type: Boolean,
      default: false
    },
    showDetail: {
      type: Boolean,
      default: false
    },
    priceData: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  methods: {
    setConsignmentPrice(id) {
      this.$emit('select', id);
    },
    createConsignment(id) {
      this.$router.push({
        name: 'create_consignment',
        params: {
          priceData: {
            ...this.priceData,
            provider_id: id
          }
        }
      });
    },
    getProviderLogo
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>

<style>
.consignment-price {
  position: relative;
  padding: 0;
}

.consignment-price-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.consignment-price-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 15px;
  padding-right: 15px;
  border-right: 1px solid #e8e8e8;
  width: 160px;
}

.consignment-price-logo-container {
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  margin-bottom: 10px;
  border-radius: 5px;
  padding: 5px;
  border: 1px solid #f3f3f3;
}

.consignment-price-logo img {
  max-width: calc(100% - 20px);
  max-height: 50px;
}

.consignment-price-logo span {
  font-size: 18px;
  font-weight: 500;
}

.consignment-best-price {
  font-size: 23px;
  display: flex;
  align-items: center;
}
.consignment-best-price .badge {
  font-size: 11px;
  margin-right: 10px;
}

.consignment-price-informations span {
  font-weight: 600;
}
.consignment-price-left {
  display: flex;
  align-items: center;
}
.consignment-price-right {
  display: flex;
  align-items: end;
  flex-direction: column;
}

@media (max-width: 1500px) and (min-width: 992px) {
  .consignment-price-left {
    display: block;
  }
  .consignment-price-right {
    display: block;
    align-items: start;
  }
  .consignment-price-logo {
    border-right: 0;
    margin-right: 0;
    padding-right: 0;
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e8e8e8;
  }
}

@media (max-width: 1500px) and (min-width: 768px) {
  .consignment-price {
    padding: 10px;
  }
}

@media (max-width: 767px) {
  .consignment-price-left {
    display: block;
  }
  .consignment-price-right {
    display: block;
    align-items: left;
  }
  .consignment-price-logo {
    border-right: 0;
    margin-right: 0;
    padding-right: 0;
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e8e8e8;
  }
  .consignment-price {
    padding: 0;
  }
  .consignment-best-price {
    display: flex;
    flex-direction: column;
  }
  .consignment-best-price .badge {
    margin-right: 0;
    margin-bottom: 10px;
  }
}

@media (max-width: 360px) {
  .consignment-price-details {
    flex-direction: column;
  }
  .consignment-price-left {
    margin-bottom: 15px;
  }
}
.consignment-price-informations {
  font-size: 12px;
}

body.dark-layout .consignment-price-logo {
  border-color: #151d32 !important;
}
.consignment-price-container {
  transition-duration: 0.2s;
}
.consignment-select-offer {
  margin-top: 10px;
}

.consignment-price-container {
  border: 2px solid #fff !important;
}
body.dark-layout .consignment-price-container {
  border-color: #293046 !important;
}
.selected-consignment-price,
body.dark-layout .selected-consignment-price {
  border-color: #01a7ce !important;
}
</style>
